// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webhook-detail {
  max-width: 1400px;
  margin: 0 auto;
}

.detail-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding: 30px 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.detail-header h1 {
  font-size: 32px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.detail-layout {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 24px;
  align-items: start;
}

/* Left: Config Section */
.config-section {
  position: sticky;
  top: 20px;
}

.config-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

.config-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f3f4f6;
}

.config-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.config-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.config-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.config-item label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.config-value {
  font-size: 14px;
  color: #1f2937;
}

.config-value strong {
  color: #1f2937;
  font-weight: 600;
}

.url-display-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f9fafb;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.url-display-compact code {
  flex: 1 1;
  font-size: 11px;
  color: #1f2937;
  word-break: break-all;
  font-family: 'Courier New', monospace;
  line-height: 1.4;
}

.btn-copy-small {
  background: #667eea;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.btn-copy-small:hover {
  background: #5568d3;
}

.response-preview-compact {
  background: #f9fafb;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  font-family: 'Courier New', monospace;
  font-size: 11px;
  color: #111827;
  font-weight: 500;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 150px;
  overflow-y: auto;
  margin: 0;
}

/* Right: Events Section */
.events-section {
  min-height: 400px;
}

.events-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 28px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px);
  max-height: 800px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f3f4f6;
  flex-shrink: 0;
}

.section-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.events-container {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 8px;
}

.events-container::-webkit-scrollbar {
  width: 8px;
}

.events-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.events-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.events-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.event-card {
  background: #f9fafb;
  border-radius: 12px;
  padding: 24px;
  border: 2px solid #e5e7eb;
  flex-shrink: 0;
}

.event-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.event-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-expand {
  background: #667eea;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.btn-expand:hover {
  background: #5568d3;
  transform: scale(1.1);
}

.event-method {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.event-timestamp {
  font-size: 12px;
  color: #6b7280;
}

.event-body {
  display: grid;
  gap: 20px;
}

.event-section h4 {
  font-size: 12px;
  color: #374151;
  margin-bottom: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.event-section pre {
  background: white;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  overflow-x: auto;
  font-size: 13px;
  font-family: 'Courier New', monospace;
  color: #111827;
  font-weight: 500;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 200px;
  overflow-y: auto;
  line-height: 1.6;
  margin: 0;
}

.no-events {
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;
  font-size: 14px;
}

.no-events p {
  margin: 0;
}

.loading {
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
  font-size: 14px;
}

.load-more-trigger {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-more {
  color: #6b7280;
  font-size: 12px;
  padding: 10px;
}

.status-badge {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-block;
}

.status-200 {
  background: #d1fae5;
  color: #065f46;
}

.status-500 {
  background: #fee2e2;
  color: #991b1b;
}

.status-404 {
  background: #fef3c7;
  color: #92400e;
}

/* Event Modal */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.event-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease-out;
  padding: 20px;
}

.event-modal-content {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease-out;
  display: flex;
  flex-direction: column;
}

.event-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 2px solid #f3f4f6;
  flex-shrink: 0;
}

.event-modal-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.event-modal-close {
  background: none;
  border: none;
  font-size: 32px;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s;
}

.event-modal-close:hover {
  background: #f3f4f6;
  color: #1f2937;
}

.event-modal-body {
  padding: 28px;
  flex: 1 1;
  overflow-y: auto;
}

.event-modal-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f3f4f6;
}

.event-modal-info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.event-modal-info-item strong {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.event-modal-info-item span {
  font-size: 14px;
  color: #1f2937;
}

.event-modal-section {
  margin-bottom: 24px;
}

.event-modal-section:last-child {
  margin-bottom: 0;
}

.event-modal-section h3 {
  font-size: 14px;
  color: #374151;
  margin-bottom: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.event-modal-pre {
  background: #f9fafb;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e5e7eb;
  overflow-x: auto;
  font-size: 13px;
  font-family: 'Courier New', monospace;
  color: #111827;
  font-weight: 500;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 500px;
  overflow-y: auto;
  line-height: 1.6;
  margin: 0;
}

/* Responsive */
@media (max-width: 1024px) {
  .detail-layout {
    grid-template-columns: 1fr;
  }

  .config-section {
    position: static;
  }

  .events-card {
    height: auto;
    max-height: 600px;
  }

  .event-modal-content {
    max-width: 100%;
    margin: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WebhookDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".webhook-detail {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.detail-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  padding: 30px 40px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.detail-header h1 {\n  font-size: 32px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.detail-layout {\n  display: grid;\n  grid-template-columns: 350px 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n/* Left: Config Section */\n.config-section {\n  position: sticky;\n  top: 20px;\n}\n\n.config-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n}\n\n.config-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #f3f4f6;\n}\n\n.config-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.config-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.config-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.config-item label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.config-value {\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.config-value strong {\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.url-display-compact {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f9fafb;\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.url-display-compact code {\n  flex: 1;\n  font-size: 11px;\n  color: #1f2937;\n  word-break: break-all;\n  font-family: 'Courier New', monospace;\n  line-height: 1.4;\n}\n\n.btn-copy-small {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.btn-copy-small:hover {\n  background: #5568d3;\n}\n\n.response-preview-compact {\n  background: #f9fafb;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  font-family: 'Courier New', monospace;\n  font-size: 11px;\n  color: #111827;\n  font-weight: 500;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 150px;\n  overflow-y: auto;\n  margin: 0;\n}\n\n/* Right: Events Section */\n.events-section {\n  min-height: 400px;\n}\n\n.events-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 200px);\n  max-height: 800px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #f3f4f6;\n  flex-shrink: 0;\n}\n\n.section-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.events-container {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-right: 8px;\n}\n\n.events-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.events-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.events-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.events-container::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.event-card {\n  background: #f9fafb;\n  border-radius: 12px;\n  padding: 24px;\n  border: 2px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.event-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.event-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.btn-expand {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.btn-expand:hover {\n  background: #5568d3;\n  transform: scale(1.1);\n}\n\n.event-method {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.event-timestamp {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.event-body {\n  display: grid;\n  gap: 20px;\n}\n\n.event-section h4 {\n  font-size: 12px;\n  color: #374151;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.event-section pre {\n  background: white;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  overflow-x: auto;\n  font-size: 13px;\n  font-family: 'Courier New', monospace;\n  color: #111827;\n  font-weight: 500;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 200px;\n  overflow-y: auto;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.no-events {\n  text-align: center;\n  padding: 60px 20px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.no-events p {\n  margin: 0;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px 20px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.load-more-trigger {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading-more {\n  color: #6b7280;\n  font-size: 12px;\n  padding: 10px;\n}\n\n.status-badge {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  display: inline-block;\n}\n\n.status-200 {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-500 {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-404 {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n/* Event Modal */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.event-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  animation: fadeIn 0.2s ease-out;\n  padding: 20px;\n}\n\n.event-modal-content {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideUp 0.3s ease-out;\n  display: flex;\n  flex-direction: column;\n}\n\n.event-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 28px;\n  border-bottom: 2px solid #f3f4f6;\n  flex-shrink: 0;\n}\n\n.event-modal-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.event-modal-close {\n  background: none;\n  border: none;\n  font-size: 32px;\n  color: #6b7280;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.event-modal-close:hover {\n  background: #f3f4f6;\n  color: #1f2937;\n}\n\n.event-modal-body {\n  padding: 28px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.event-modal-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #f3f4f6;\n}\n\n.event-modal-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.event-modal-info-item strong {\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.event-modal-info-item span {\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.event-modal-section {\n  margin-bottom: 24px;\n}\n\n.event-modal-section:last-child {\n  margin-bottom: 0;\n}\n\n.event-modal-section h3 {\n  font-size: 14px;\n  color: #374151;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.event-modal-pre {\n  background: #f9fafb;\n  padding: 20px;\n  border-radius: 8px;\n  border: 2px solid #e5e7eb;\n  overflow-x: auto;\n  font-size: 13px;\n  font-family: 'Courier New', monospace;\n  color: #111827;\n  font-weight: 500;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 500px;\n  overflow-y: auto;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .detail-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .config-section {\n    position: static;\n  }\n\n  .events-card {\n    height: auto;\n    max-height: 600px;\n  }\n\n  .event-modal-content {\n    max-width: 100%;\n    margin: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
